import { lazy, Suspense } from "react";

import { currentRoutesByRole } from "./routesbyRole";
import Loader from "components/Loader";

const Home = lazy(() => import("pages/Login/index"));
const Layout = lazy(() => import("layout/Layout"));
const NotFound = lazy(() => import("pages/NotFound"));
const SupportLayout = lazy(() => import("layout/SupportLayout"));
const PrivacyPolicy = lazy(() => import("pages/help/PrivacyPolicy"));
const UserAgreement = lazy(() => import("pages/help/UserAgreement"));
const DeleteAccountInstruction = lazy(() =>
  import("pages/help/DeleteAccountInstruction")
);

export const mainRoutes = [
  {
    path: "login",
    element: (
      <Suspense fallback={<Loader />}>
        <Home />
      </Suspense>
    ),
  },

  {
    path: "help",
    element: (
      <Suspense fallback={<Loader />}>
        <SupportLayout />
      </Suspense>
    ),
    children: [
      {
        path: "privacyPolicy",
        element: (
          <Suspense fallback={<Loader />}>
            <PrivacyPolicy />
          </Suspense>
        ),
      },
      {
        path: "userAgreement",
        element: (
          <Suspense fallback={<Loader />}>
            <UserAgreement />
          </Suspense>
        ),
      },

      {
        path: "deleteAccount",
        element: (
          <Suspense fallback={<Loader />}>
            <DeleteAccountInstruction />
          </Suspense>
        ),
      },
    ],
  },

  {
    path: "",
    element: (
      <Suspense fallback={<Loader />}>
        <Layout />
      </Suspense>
    ),
    children: currentRoutesByRole(),
  },

  {
    path: "*",
    element: (
      <Suspense fallback={<Loader />}>
        <NotFound />
      </Suspense>
    ),
  },
];
